module.exports = __webpack_public_path__ + "img/domain-com-au.112c7b9e.png";